module.exports = __webpack_public_path__ + "assets/img/1601_02.jpg?4d3ea44ed9b110e113256a1d910060c5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1601_02.jpg
// module id = 1096
// module chunks = 0